import type { KalturaLogoAsset } from '../../composed';
import { createChannelFilter, createOnDemandResponseProfile, createPager } from '../../factories';
import { fetchAssetList } from '../../services';
import { withCollectionFallback } from '../utils';

import { processLogo } from './processLogo';

export type FetchLogoArgs = {
  collectionId: number;
  kSql?: string;
};

const retrievedProperties = 'id,images,error,type';

export async function fetchLogo({ collectionId, kSql }: FetchLogoArgs) {
  const { objects } = await withCollectionFallback(() =>
    fetchAssetList<KalturaLogoAsset>({
      filter: createChannelFilter({
        idEqual: collectionId,
        kSql,
      }),
      pager: createPager({
        pageIndex: 1,
        pageSize: 20,
      }),
      responseProfile: createOnDemandResponseProfile({
        retrievedProperties,
      }),
    }),
  );

  const logo = objects[0];

  if (!logo) {
    return {
      logo: undefined,
    };
  }

  return {
    logo: processLogo(logo),
  };
}
